import { useMutation } from '@tanstack/react-query'
import { useAuth } from 'src/contexts/auth'
import { AnimalController } from 'src/controllers/animal.controller'
import { CreateVaccineHistoryDto } from 'src/dto/animal.dto'

const animalController = new AnimalController()

export function useCreateAnimalVaccineHistoric(scope: string = 'createAnimalVaccineHistoric') {
  const { userFarm: farmId } = useAuth()

  return useMutation<any, Error, CreateVaccineHistoryDto>({
    mutationKey: [scope],
    mutationFn: (data: CreateVaccineHistoryDto) => animalController.createAnimalVaccineHistoric(farmId!, data)
  })
}
